import { DeploymentEnvironment } from '@hclinear/hc-linear-react';

export const theme = {
  text: {
    textLight: 'var(--text-color-light)',
    textDark: 'var(--text-color-dark)',
  },
  colors: {
    primary: 'var(--primary-color)',
    primaryHover: 'var(--primary-color-hover)',
    secondary: 'var(--secondary-color)',
    secondaryHover: 'var(--secondary-color-hover)',
    main: 'var(--main-color)',
    textLight: 'var(--text-color-light)',
    textDark: 'var(--text-color-dark)',
    textDarker: 'var(--text-color-darker)',
    textLighter: 'var(--text-color-lighter)',
    border: 'var(--border-color)',
    backgroundLight: 'var(--background-color-light)',
    backgroundDark: 'var(--background-color-dark)',
    buttonBackground: 'var(--button-background-color)',
    buttonHover: 'var(--button-background-color-hover)',
    buttonGrey: 'var(--button-background-color-grey)',
    buttonDisabled: 'var(--button-background-color-disabled)',
    disabled: 'var(--disabled-color)',
    cancelDeleteButton: 'var(--cancel-delete-button-color)',
  },
  borderRadius: {
    small: '6px',
    medium: '8px',
    large: '15px',
  },
  border: {
    light: '1px solid var(--border-color)',
  },
  spacing: {
    padding: '40px',
    gapSmall: '8px',
    gapMedium: '16px',
  },
  BOX_SHADOW: {
    BUTTON: '0 2px 6px rgba(0, 0, 0, 0.1)',
    BUTTON_HOVER: '0 4px 10px rgba(0, 0, 0, 0.15)',
  },
};

export const deploymentBorderColors: Record<DeploymentEnvironment, string> = {
  [DeploymentEnvironment.LOCAL]: 'var(--button-background-color-hover)',
  [DeploymentEnvironment.DEV]: '#e5332a',
  [DeploymentEnvironment.QA]: '#f8b133',
  [DeploymentEnvironment.PROD]: null,
};
